/**
 * Links to videos local pages for fallback in case a URL is deleted
 */

const LocalFallbackUrls = {};

LocalFallbackUrls.LFB_HOME = '/';
LocalFallbackUrls.LFB_MUSIC = '/music';

export default LocalFallbackUrls;